module.exports = __webpack_public_path__ + "img/zh.3010364a.png";